import { render, staticRenderFns } from "./Akamai.vue?vue&type=template&id=0c4da17a&"
import script from "./Akamai.vue?vue&type=script&lang=js&"
export * from "./Akamai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports